import { ulid } from 'ulid';

import { WsSalesSolutionOfferingRoleInterface } from './core';
import { getValue } from './helpers/item-helpers';




class WsSalesSolutionOfferingRoleClass implements WsSalesSolutionOfferingRoleInterface {
  id = '';
  staticId = '';
  name = '';
  value = 100;
  team = 'AVANADE';
  location = 'ONSHORE_UK';
  aep: any = {};
  governance = false;

  constructor(properties: { name: string, id?: string, team?: string, location?: string, aep?: any, governance?: boolean }) {

    this.id = properties.id ? properties.id : ulid();

    this.name = properties.name;
    
    this.value = 100;

    if (properties.team) {
      this.team = properties.team;
    }

    if (properties.location) {
      this.location = properties.location;
    }

    if (properties.aep) {
      this.aep = properties.aep;
    }

    if (properties.governance) {
      this.governance = properties.governance;
    } else {
      this.governance = false;
    }
  }

  // TODO: move this to base class
  // return: polymorphic this
  // https://www.typescriptlang.org/docs/handbook/2/classes.html#this-types
  clone(): this {
    const c = Object.assign(Object.create(Object.getPrototypeOf(this)), this);
    c.id       = ulid();
    c.staticId = this.id;
    return c;
  }

  copy(): this {
    const c = Object.assign(Object.create(Object.getPrototypeOf(this)), this);
    return c;
  }
}







export const getSalesCapabilityRolesFromConfig = (roles: WsSalesSolutionOfferingRoleInterface[]): WsSalesSolutionOfferingRoleClass[] => {
  const list: WsSalesSolutionOfferingRoleClass[] = [];

  roles.forEach((role) => {
    list.push(new WsSalesSolutionOfferingRoleClass({ id: role.id, name: role.name, team: role.team, location: role.location, aep: role.aep, governance: getValue(role.governance, false) }));
  });

  return list;
};








class WsSalesSolutionOfferingClass {
}




class WsSalesSolutionActionClass {
}




class WsSalesSolutionMetricClass {
}




class WsSalesSolutionRiskClass {
  id: string = '';
  name: string = '';
  consequence: string = '';
  mitigation: string = '';
  impact: string = '';
  probability: string = '';
  owner?: WsSalesSolutionOfferingRoleClass = undefined;
  comments: string = '';

  constructor(name: string) {
    this.id = ulid();
    this.name = name;
  }
}




class WsSalesSolutionAssumptionClass {
}




class WsSalesSolutioDependencyClass {
}




class WsSalesSolutionAcceptanceCriteriaClass {
  id: string = '';
  name: string = '';
  selected: boolean = false;

  constructor(name: string) {
    this.id = ulid();
    this.name = name;
  }
}

const salesOfferingAcceptanceCriteria = {
  deliverables: [
    new WsSalesSolutionAcceptanceCriteriaClass('5-5-2'),
    new WsSalesSolutionAcceptanceCriteriaClass('2-2-1'),
    new WsSalesSolutionAcceptanceCriteriaClass('10-10-5')
  ],
  workProducts: [
    new WsSalesSolutionAcceptanceCriteriaClass('Email confirmation to the client')
  ]
};




class WsSalesSolutionDeliverableClass {
  id: string = '';
  name: string = '';
  description: string = '';
  acceptanceCriteria: WsSalesSolutionAcceptanceCriteriaClass[] = salesOfferingAcceptanceCriteria.deliverables;
  format: WsSalesDocumentFormatInterface = { id: '', name: 'None' };
  documentId?: string;
  reviewSettings?: {
    cycles:  number;
    review:  number;
    update:  number;
    approve: number;
  };

  constructor(name: string) {
    this.id = ulid();
    this.name = name;
  }
}




class WsSalesSolutionWorkProductClass {
  id: string = '';
  name: string = '';
  description: string = '';
  acceptanceCriteria: WsSalesSolutionAcceptanceCriteriaClass[] = salesOfferingAcceptanceCriteria.workProducts;
  format: WsSalesDocumentFormatInterface = { id: '', name: 'None' };
  documentId?: string;

  constructor(name: string) {
    this.id = ulid();
    this.name = name;
  }
}




class WsSalesSolutionToolClass {
  id: string = '';
  name: string = '';

  constructor(name: string) {
    this.id = ulid();
    this.name = name;
  }
}




export interface WsSalesDocumentFormatInterface {
  id: string;
  name: string;
};




const documentFormats: WsSalesDocumentFormatInterface[] = [
  {
    id: '',
    name: 'None'
  },
  {
    id: '01H9QET9SWYY7PWA00PQ226N2S',
    name: 'Word'
  },
  {
    id: '01H9QETGMNARHXTMYEFM9K5720',
    name: 'Excel'
  },
  {
    id: '01H9QETP23TJCS2A1R5HC9VD8Q',
    name: 'PowerPoint'
  },
  {
    id: '01H9QETT1NZDV1X6PZE8VW3BNS',
    name: 'PDF'
  },
];




export {
  documentFormats,

  WsSalesSolutionOfferingRoleClass,
  // WsSalesSolutionOfferingClass,
  // WsSalesSolutionActionClass,
  WsSalesSolutionMetricClass,

  WsSalesSolutionRiskClass,
  // WsSalesSolutionAssumptionClass,
  // WsSalesSolutioDependencyClass,

  WsSalesSolutionAcceptanceCriteriaClass,
  salesOfferingAcceptanceCriteria,
  
  WsSalesSolutionDeliverableClass,
  WsSalesSolutionWorkProductClass,
  WsSalesSolutionToolClass
};
